import type { RefObject } from 'react';

import { createSafeContext } from '@/util';

const FileBrowserScrollContext = createSafeContext<{
  $scrollable: RefObject<HTMLDivElement>;
}>();

export default FileBrowserScrollContext;
